var _excluded = ["href"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls } from '@okee-uikit/react-config';
import { More } from '../../../common/icons';
import { useChildrenEnterLeave } from '../../../hooks/animation';
import { Dropdown } from '../../dropdown';
import { Item } from './Item';
import { BreadcrumbItem } from './BreadcrumbItem';
import { SegmentedAnimation } from './segmentedAnimation';
export function Breadcrumb(props) {
  var _props$type = props.type,
      type = _props$type === void 0 ? 'basic' : _props$type,
      _props$max = props.max,
      max = _props$max === void 0 ? 3 : _props$max,
      itemMaxWidth = props.itemMaxWidth,
      className = props.className,
      style = props.style,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      onClick = props.onClick,
      children = props.children;
  var items = [];
  var collapsedItems = [];
  var childrenCount = React.Children.count(children);
  var mid = Math.ceil(max / 2);
  var handleClick = useRefCallback(onClick);
  var cls = classnames(usePrefixCls('breadcrumb', {
    type: type
  }), className);
  var separatorCls = usePrefixCls('breadcrumb-separator');
  var moreCls = usePrefixCls('breadcrumb-more');
  var groupCls = usePrefixCls('breadcrumb-group');
  React.Children.forEach(children, function (child, index) {
    var _child$props = child.props,
        href = _child$props.href,
        rest = _objectWithoutProperties(_child$props, _excluded);

    var props = _objectSpread(_objectSpread({}, rest), {}, {
      index: index,
      href: href,
      onClick: handleClick,
      itemMaxWidth: itemMaxWidth,
      active: index === childrenCount - 1
    });

    var key = "".concat(href, "-").concat(props.id || index);

    if (type !== 'basic' && childrenCount > max && items.length >= mid && collapsedItems.length < childrenCount - max) {
      props.collapsed = true;
      collapsedItems.push(React.createElement(Item, _objectSpread({
        key: key
      }, props)));
    } else {
      props.collapsed = false;
      items.push(React.createElement("div", {
        className: groupCls,
        key: key
      }, !!index && React.createElement("div", {
        className: separatorCls
      }, separator), React.createElement(Item, _objectSpread({
        key: key
      }, props))));
    }
  });

  if (collapsedItems.length) {
    var dropdown = React.createElement("div", {
      className: groupCls,
      key: "breadcrumb-dropdown"
    }, React.createElement("div", {
      className: separatorCls
    }, separator), React.createElement("div", {
      className: moreCls
    }, React.createElement(Dropdown, {
      trigger: "hover",
      placement: "bottom",
      offset: {
        x: 0,
        y: 4
      },
      menu: React.createElement(Dropdown.Menu, {
        onClick: function onClick(href) {
          return handleClick(href);
        }
      }, collapsedItems)
    }, React.createElement(More, null))));
    items.splice(max - 1, 0, dropdown);
  }

  var _useChildrenEnterLeav = useChildrenEnterLeave(items, SegmentedAnimation(200)),
      _useChildrenEnterLeav2 = _slicedToArray(_useChildrenEnterLeav, 2),
      animatedChildren = _useChildrenEnterLeav2[0],
      start = _useChildrenEnterLeav2[1];

  useEffect(start);
  return React.createElement("div", {
    className: cls,
    style: style
  }, animatedChildren);
}
Breadcrumb.Item = BreadcrumbItem;